import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="tool-copy"
// Copies a field's value (input/textarea) or tag list to the clipboard.
export default class extends Controller {
  static targets = ['source', 'button']

  copy() {
    navigator.clipboard?.writeText(this.sourceText())
    this.buttonTarget.textContent = 'Copied'
    this.buttonTarget.classList.add('copied')
    clearTimeout(this.revertTimer)
    this.revertTimer = setTimeout(() => {
      this.buttonTarget.textContent = 'Copy'
      this.buttonTarget.classList.remove('copied')
    }, 1600)
  }

  sourceText() {
    const source = this.sourceTarget
    if ('value' in source && source.tagName !== 'DIV') return source.value

    return Array.from(source.children)
      .map((tag) => tag.textContent.trim())
      .join(', ')
  }

  disconnect() {
    clearTimeout(this.revertTimer)
  }
}
